import type { ResponsiveRankingColumn } from "../../../shared/components/ResponsiveRankingTable";
import { POCO_ROUNDS } from "./pocoSchedule";

export type PocoRankingPoints = {
  points: number;
  roundPoints: number[];
  isPocoChampion?: boolean;
  isPocoFinalLoser?: boolean;
};

export function getPocoRankingRoundCount(rounds: readonly unknown[] | null | undefined) {
  return Math.max(POCO_ROUNDS, rounds?.length || 0);
}

export function buildPocoRankingColumns<T extends PocoRankingPoints>(
  roundCount: number,
  labels = { total: "Total", final: "Final", roundShort: "R" },
): ResponsiveRankingColumn<T>[] {
  return [
    { id: "points-total", header: labels.total, mobileLabel: labels.total, render: row => row.points },
    ...Array.from({ length: roundCount }, (_, index): ResponsiveRankingColumn<T> => {
      const final = index === roundCount - 1;
      const label = final ? labels.final : `${labels.roundShort}${index + 1}`;
      return { id: `round-${index + 1}`, header: label, mobileLabel: label,
        render: row => final
          ? row.isPocoChampion ? "🏆" : row.isPocoFinalLoser ? "❌" : "—"
          : Number(row.roundPoints[index] || 0) };
    }),
  ];
}
